import _get from "lodash/get";
import { AnyAction } from "redux";
import { PrepaidRegistrationState } from "../../../../../models/state";
import * as AUTH_AT from "../../../authentication/state/actionTypes";
import * as PREPAID_AT from "../actionTypes";

export function fulfilled(actionType: keyof typeof AUTH_AT | keyof typeof PREPAID_AT) {
    return `${actionType}_FULFILLED`;
}

export const initialState = (): PrepaidRegistrationState => ({
    isSimNumberValid: false,
    isOrderComplete: false,
});

const reducer = (state = initialState(), action: AnyAction): PrepaidRegistrationState => {
    switch (action.type) {
        case fulfilled(PREPAID_AT.PREPAID_REFILL_VERIFY_PHONE_NUMBER):
            return {
                ...state,
            };
        case fulfilled(PREPAID_AT.PREPAID_REGISTRATION_VERIFY_UPDATED_NAME):
            return {
                ...state,
            };
        case fulfilled(PREPAID_AT.PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER):
            return {
                ...state,
                isOrderComplete: _get(action, "payload.status") === "OK",
            };
        default:
            return state;
    }
};

export default reducer;
